module.exports = __webpack_public_path__ + "img/t.64885285.png";